import {useCallback} from "react"
import {useThemeValue} from "stores/theme"
import {applyTheme} from "./applyTheme"
import {ThemeTypeEnum} from "./data"

export const useTheme = () => {
  const theme = useThemeValue()
  const isDarkMode = theme === ThemeTypeEnum.enum.dark

  const toggleTheme = useCallback(() => {
    applyTheme(isDarkMode ? ThemeTypeEnum.enum.light : ThemeTypeEnum.enum.dark)
  }, [isDarkMode])

  return {
    theme,
    toggleTheme,
    isDarkMode,
  }
}
